import React from 'react';
import { signupStyles } from '@/components/features/registration/signup-templates/signup.styles';
import { Box, Stack, Button, Field, createListCollection } from '@chakra-ui/react';
import { specializationSchema, TSpecialization } from './specialization.validator';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { TClinicDetailsProps } from '../../../templates/clinic/types/template.types';
import MultiSelect from '@/components/ui/MultiSelect/MultiSelect';

const SpecializationForm = ({ next, details }: TClinicDetailsProps) => {
   const {
      register,
      handleSubmit,
      reset,
      formState: { errors },
   } = useForm<TSpecialization>({
      defaultValues: {
         specialization: details.specializations || [],
      },
      resolver: zodResolver(specializationSchema),
   });

   const onSubmit = handleSubmit(async data => {
      next('appointmentFee', { specializations: data.specialization });
   });

   const specializationOptions = [
      'pain',
      'sleep',
      'trauma',
      'mental illness',
      'neurological issues',
      'terminal / chronic disease',
   ];

   return (
      <Box as="form" css={signupStyles.signup_form} onSubmit={onSubmit}>
         <Stack gap="4" align="flex-start" minW="full">
            <Field.Root invalid={Boolean(errors.specialization?.message)}>
               <Field.Label textStyle="xs" color="white" mb="1">
                  Specialisation
                  <Box as="span" color="error">
                     *
                  </Box>
               </Field.Label>
               <MultiSelect
                  multiple
                  placeholder="Specialization"
                  {...register('specialization')}
                  collection={createListCollection({
                     items: specializationOptions.map(item => ({ label: item, value: item })),
                  })}
               />
               <Field.ErrorText>{errors.specialization?.message}</Field.ErrorText>
            </Field.Root>
            <Box css={signupStyles.signup_btn_con}>
               <Button
                  type="reset"
                  onClick={() => reset()}
                  bg="darkerBtn"
                  textStyle="xs"
                  color="white"
                  h="10"
                  maxW="36"
                  minW="36"
                  p="0"
               >
                  Reset
               </Button>
               <Button type="submit" textStyle="xs" h="10" maxW="36" minW="36" p="0">
                  Next
               </Button>
            </Box>
         </Stack>
      </Box>
   );
};

export default SpecializationForm;
